import { buildModelManager } from "../builder.js";
const DefaultPhiAccessAuditSelection = {
  __typename: true,
  id: true,
  action: true,
  actorId: true,
  createdAt: true,
  institution: true,
  metadata: true,
  occurredAt: true,
  purpose: true,
  requesterIpHash: true,
  status: true,
  updatedAt: true,
  vaultObjectId: true
};
const modelApiIdentifier = "phiAccessAudit";
const pluralModelApiIdentifier = "phiAccessAudits";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiAccessAuditSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "phiAccessAuditGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PhiAccessAuditManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPhiAccessAuditSelection,
  operations
);
export {
  DefaultPhiAccessAuditSelection,
  PhiAccessAuditManager
};
//# sourceMappingURL=PhiAccessAudit.js.map
